export const GET_FILTERED_BRAND_METAS = "GET_FILTERED_BRAND_METAS"
export const GET_FILTERED_BRAND_META_TRANSLATIONS = "GET_BRAND_META_TRANSLATIONS"
export const GET_FILTERED_BRAND_METAS_NAME = "GET_FILTERED_BRAND_METAS_NAME"
export const GET_FILTERED_BRAND_META_TRANSLATIONS_NAME = "GET_BRAND_META_TRANSLATIONS_NAME"

export const GET_FILTERED_CATEGORY_METAS = "GET_FILTERED_CATEGORY_METAS"
export const GET_FILTERED_CATEGORY_META_TRANSLATIONS = "GET_CATEGORY_META_TRANSLATIONS"
export const GET_FILTERED_CATEGORY_METAS_NAME = "GET_FILTERED_CATEGORY_METAS"
export const GET_FILTERED_CATEGORY_META_TRANSLATIONS_NAME = "GET_CATEGORY_META_TRANSLATIONS"

export const GET_PAGE_METAS = "GET_PAGE_METAS"
export const GET_PAGE_META_TRANSLATIONS ="GET_PAGE_META_TRANSLATIONS"